import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {RegisterLegacyAction} from '@netx/core/legacyActionManager';
import AppViewsCollection from '../collections/appViews';

export const fsViews = new AppViewsCollection([]);

RegisterLegacyAction([
	{
		event: 'app:remove:fsView',
		label: '',
		wrapper: function (v: any) {
			return [v.model];
		},
	},
]);

/**
 * Removes all fullscreen views (and in turn closes the fullscreen view if open)
 * @event module:app#app:reset:fsViews
 */
dispatcher.on('app:reset:fsViews', function () {
	fsViews.set([]);
});

/**
 * @event module:app#app:remove:fsView
 * @param {Netx.Models.AppView} appView App view model
 */
dispatcher.on('app:remove:fsView', function (appView: any) {
	const view = appView.get('view');
	if (!view) return;

	// TODO: set property that tells us if this is a form view - no need to be doing this instance of stuff
	// in the current state it would be something like: `isFormView: true`
	// when we start extending functionality and not whole views we can keep an array of the funstionality
	// that has been extended - `functionality: ['form', 'table']`

	// Let the view know it has been `cancelled`
	// Allows us to utlize the standard event system
	if (view.hasFunctionality('form') && typeof view.cancel === 'function') {
		appView.collection._listenId === fsViews._listenId && view.cancel();
		return;
	}
	// Will remove from fs childViews
	fsViews.remove(appView.id);
	// Let the hide stuff run so we do not get jerky results
	// all fs views are set to remove on hidden so long as the simple param is not passed
	// view.hide();
});

export default fsViews;

import {setGlobal} from '@netx/core-next/utils/setGlobal';
setGlobal({fsViews});
